import base from '@nextories/vue-core-components/src/i18n/langs/fr/base';

export default {
  ...base,
  cancel: 'Annuler',
  back: 'Retour',
  edit: 'Éditer',
  yes: 'Oui',
  no: 'Non',
  dates: 'Dates',
  priceType: 'HT | TTC',
  to: 'à',
  validate: 'Validé',
  send: 'Envoyer',
  choose: 'Choisir',
  sign: 'Signer',
  mover: 'Déménageur',
  move: 'Déménagement',
  file: 'Fichier',
  fileUpload: 'Upload des fichiers',
  save: 'Sauvegarder',
  saved: 'Sauvegardé',
  loading: 'Chargement de l\'application',
  quantity: 'Quantité',
  partnerDiscountBanner: 'Réduction partenaire -{rate}%',
  partnerDiscountBannerWithoutRate: 'Réduction partenaire',
  partnerDiscountInfoLine1: 'Offre promotionnelle réservée aux clients issus de notre partenaire {partnerName}.',
  partnerDiscountInfoLine2: 'Pour un déménagement en France métropolitaine contractualisé avec Nextories, le client bénéficie d\'une réduction appliquée sur le prix grand public hors promotion, incluant les options choisies et les suppléments éligibles à réduction, à l\'exclusion des frais de stationnement, des frais de stockage et de la garantie.',
  partnerDiscountInfoLine3: 'Offre limitée dans le temps, non rétroactive et non cumulable avec toute autre offre promotionnelle en cours.',
  volume: 'Volume',
  packaging: 'Emballage spécial',
  unpacking: 'Démontage & remontage par le déménageur',
  heavy: 'Poids > 100kg',
  with: 'avec',
  other: 'autre',
  next: 'Suivant',
  days: {
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche',
  },
  monthsMin: {
    january: 'Jan',
    february: 'Fev',
    march: 'Mar',
    april: 'Avr',
    may: 'Mai',
    june: 'Juin',
    july: 'Juil',
    august: 'Aoû',
    september: 'Sep',
    october: 'Oct',
    november: 'Nov',
    december: 'Dec',
  },
  minarm_organism: 'CIMOB',
  minarm_organism_le: 'le CIMOB',
  minarm_organism_du: 'du CIMOB',
  minarm_organism_au: 'au CIMOB',
  phoneNumber: '01 82 52 10 12',
  alter: 'Modifier',
  warning: 'Attention',
  moving: 'Déménagement',
  ignore: 'Ignorer',
  hoursUnit: 'H',
  minutesUnit: 'min',
};
